<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      title="Bons de commande"
      subtitle="Recherche de bons de commande"
      autocomplete_idHistory="account-statements"
      bdTable="bon_de_commande"
      ref="bons_de_commande_resource"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      :directLoad="true"
    >
    </bd-table-list>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import purchaseOrder from "@/services/purchase-order.js";
export default {
  name: "PurchaseOrderHistory",
  props: {
    directLoad: {
      type: Boolean,
      default: false,
    },
    creancierID: String,
  },
  components: {
    BdTableList,
  },
  methods: {
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    deleteBonDeCommande(payload) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer ce bon de commande", {
          cancelTitle: "Annuler",
          okTitle: "Supprimer",
        })
        .then((value) => {
          if (value) {
            purchaseOrder
              .delete_po({
                id: payload.ID,
              })
              .then((response) => {
                if (response.data.success) {
                  this.$refs.bons_de_commande_resource.submitSearch(true);
                }
              });
          }
        });
    },
  },
  data() {
    return {
      Api: purchaseOrder,
      releve_id: null,
      breadcrumb: [
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Bons de commande",
          active: true,
        },
      ],
      actions: [
        {
          label: "Supprimer",
          action: (id) => this.deleteBonDeCommande({ ID: id }),
          icon: "x-circle-fill",
          variant: "danger",
          condition: () => this.$store.getters.isSuperAdmin,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px",
        },
        {
          key: "date_sent",
          label: "Date d'envoi",
          sortable: true,
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "initiale",
          label: "Utilisateur",
          sortable: true,
          class: "text-truncate",
          thStyle: { width: "250px" },
        },
        {
          key: "firme",
          label: "Firme",
          sortable: true,
        },
        {
          key: "numero_entreprise",
          label: "N° d'entreprise",
        },
        {
          key: "adresse",
          label: "Adresse",
          sortable: true,
        },
        {
          key: "nombre_mandats",
          label: "Mandats",
          formatter: (value, key, item) => {
            return (
              Number(item.nombre_mandats) +
              " mandats à " +
              Number(item.prix_unitaire) +
              " €"
            );
          },
        },
        {
          key: "prix",
          label: "Prix HTVA",
          formatter: (value, key, item) => {
            return (
              Number(item.nombre_mandats) * Number(item.prix_unitaire) + " €"
            );
          },
        },
        {
          key: "actions",
          label: "Actions",
          class: 'text-center',
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
